import React from "react";
import {IRouteProps, IViewProps} from "../../../ts/manager/view/ViewInterface";


const Error404Partial = (props:IRouteProps|IViewProps) =>
{
    return <>
        <section className="content-block">
            <div className="container">
                <div className="row">

                    <div className="col-12 text-center">
                        {props.message ?? "Page not found"}
                    </div>
                </div>
            </div>
        </section>
    </>
}

export default Error404Partial;